<div>
  {{ 'commonActions.isolateResourcePlaybookAction.description' | labelsProvider }}
</div>
